import React from 'react';
import Modal from './Modal';
import './HygieneRatingModal.css';

interface HygieneRatingModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const HygieneRatingModal: React.FC<HygieneRatingModalProps> = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={true}>

            <div className="hygiene-modal-badge-wrap">

                <img
                    src="/images/badges/badge1.svg"
                    alt="Food Hygiene Rating 5 — Very Good"
                />

            </div>
            <div className="hygiene-modal-areas">
                <div className="hygiene-modal-area">
                    <span className="hygiene-modal-area-label">Hygienic food handling</span>
                    <span className="hygiene-modal-area-value">Very good</span>
                </div>
                <div className="hygiene-modal-area">
                    <span className="hygiene-modal-area-label">Cleanliness &amp; facilities</span>
                    <span className="hygiene-modal-area-value">Very good</span>
                </div>
                <div className="hygiene-modal-area">
                    <span className="hygiene-modal-area-label">Management of food safety</span>
                    <span className="hygiene-modal-area-value">Very good</span>
                </div>
            </div>
            <p className="hygiene-modal-meta">
                Inspected 14 March 2026 by South Cambridgeshire District Council
            </p>
            <a
                href="https://ratings.food.gov.uk/business/1874096/"
                className="hygiene-modal-cta"
                target="_blank"
                rel="noopener noreferrer"
            >
                View on official FHRS register &#8599;
            </a>
        </Modal>
    );
};

export default HygieneRatingModal;
